'use strict';

module.exports = emphasis;

var all = require('../all');

function emphasis(h, node) {
  return h(node, 'emphasis', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/emphasis.js
// module id = 1024
// module chunks = 0